import { render, staticRenderFns } from "./GenericForm.vue?vue&type=template&id=467042ea&scoped=true&"
import script from "./GenericForm.vue?vue&type=script&lang=ts&"
export * from "./GenericForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467042ea",
  null
  
)

export default component.exports